import React from 'react';
import './Upload.scss';

import uploadedIcon from './file-upload-done.svg';
import Button from '../button';
import { useConfirmationDialog } from '../../core/components/confirm-popup/confirm-popup';

interface CustomProps {
  id: string;
  title: string;
  description?: string;
  filename: string;
  fileSize: string;
  onClose?: () => void;
  disabled?: boolean;
  filePath?: string;
  hideLabel?: boolean;
  sm?: boolean;
  confirmOnDelete?: boolean;
  confirmationMessage?: string;
}

const FileUploaded: React.SFC<CustomProps> = (props: CustomProps) => {
  const { getConfirmation } = useConfirmationDialog();
  const onClose = async () => {
    if (props.confirmOnDelete) {
      const granded = await getConfirmation({
        title: props.confirmationMessage || `Are you sure to remove this file?`,
      });
      if (granded) {
        props.onClose?.();
      }
    } else {
      props.onClose?.();
    }
  };
  return (
    <>
      {!props.hideLabel && <label className="fieldlabel">{props.title}</label>}
      <div
        className={`uploadfile uploadfile--spacing uploaded ${
          props.sm === true
            ? 'border-bottom px-0 pt-1 pb=3'
            : 'uploadfile--border uploadfile--curve'
        }`}
      >
        <div className="uploadfile__outer">
          <label className="uploadfile__label">
            <span className="uploadfile__filename">
              <div
                className={`uploadfile__icon ${
                  props.sm === true ? 'pr-2 mr-1' : 'px-2'
                }`}
              >
                <img
                  src={props.filePath || uploadedIcon}
                  alt=""
                  width={`${props.sm === true ? 25 : 50}`}
                  height={`${props.sm === true ? 'auto' : 50}`}
                  // style={{ objectFit: 'cover' }}
                />
              </div>
              <span className="uploadfile__filename-outer">
                <span
                  className={`uploadfile__filename-text ${
                    props.sm === true ? 'font-sm' : ''
                  }`}
                >
                  {props.filename}
                </span>
                <span
                  className={`uploadfile__filename-subtext ${
                    props.sm === true ? 'font-xxs mt-0' : ''
                  }`}
                >
                  {props.fileSize}
                </span>
              </span>
            </span>
          </label>
          {!props.disabled && (
            <Button type="button" btnlink onClick={onClose}>
              <span className="uploadfile__close">
                <i
                  className={`icon-close uploadfile__close-icon ${
                    props.sm === true ? 'text-gray-500' : ''
                  }`}
                ></i>
              </span>
            </Button>
          )}
        </div>
      </div>
    </>
  );
};

export default FileUploaded;
